module.exports = __webpack_public_path__ + "static/img/19.46616fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/19.png
// module id = PwJn
// module chunks = 0